import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "search-page-search-filter",
  name: "xpage-search-filter"
}
const _hoisted_2 = {
  name: "xpage-search-filter-scroll",
  class: "search-page-search-filter-scroll"
}
const _hoisted_3 = { class: "section-description-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "section-filters" }
const _hoisted_6 = { class: "xpage-search-filter-modal" }

import { SearchPageProperties, FilterDefinition } from "@/types/search-page";
import { PropType, ref, watch } from "vue";
import SearchPageFilterOptions from "@/components/v2/search-page/SearchPageFilterOptions.vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageFiltersModal from "@/components/v2/search-page/SearchPageFiltersModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageFilters',
  props: {
  settings: {
    type: Object as PropType<SearchPageProperties>,
  },
  filterDefinitions: {
    type: Array as PropType<Array<FilterDefinition>>,
    required: true,
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

let localData = ref<SearchPageProperties>(
  JSON.parse(JSON.stringify(props.settings))
);

const toggleIcon = (filterDefinition: FilterDefinition) => {
  if (filterDefinition) {
    return filterDefinition.collapsed
      ? "fa-solid fa-chevron-down"
      : "fa-solid fa-chevron-up";
  }

  return "fa-solid fa-chevron-down";
};

function toggleFilterSection(section: FilterDefinition) {
  const action = section.collapsed ? "expand" : "collapse";
  searchPageStore.toggleFilterSection(action, section);
}

watch(
  () => searchPageStore.searchPageState.query,
  (newQuery) => {
    localData.value.query.totalCount = newQuery.totalCount;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    name: "xpage-search-filters",
    class: _normalizeClass(["search-page-search-filters", { visible: _unref(searchPageStore).searchPageState.filterDisplay }]),
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(searchPageStore).searchPageState.filterDisplay = false), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "search-page-search-filters-close icon-x",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(searchPageStore).searchPageState.filterDisplay = false))
      }),
      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Filter Categories", -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterDefinitions, (section, index) => {
          return (_openBlock(), _createElementBlock("div", {
            name: "xpage-search-filter-section xpage-search-filter-scroll",
            class: "search-page-search-filter-section",
            key: index
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(section?.label), 1),
              _createElementVNode("span", {
                class: "section-description-icon",
                onClick: ($event: any) => (toggleFilterSection(section))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "",
                  icon: toggleIcon(section)
                }, null, 8, ["icon"])
              ], 8, _hoisted_4)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(SearchPageFilterOptions, { filterDefinition: section }, null, 8, ["filterDefinition"])
            ], 512), [
              [_vShow, !section.collapsed]
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_unref(searchPageStore).searchPageState.filterModal.active)
        ? (_openBlock(), _createBlock(SearchPageFiltersModal, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})